<template>
  <span v-if="result" class="def-img-wrapper">
    <img
      v-if="loadImage"
      :src="result.src"
      :alt="result.alt"
      :width="result.width"
      :height="result.height"
      decoding="async"
      :loading="priority ? 'eager' : 'lazy'"
      :fetchpriority="priority ? 'high' : 'auto'"
      class="def-img"
    />
  </span>
</template>

<script>
export default {
  name: 'DefImg',
  props: {
    result: Object,
    maxWidth: String,
    maxHeight: String,
    maxSizeOff: {
      type: Boolean,
      default: false,
    },
    priority: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      intersectionObserver: null,
      options: {
        rootMargin: '100px',
        threshold: 0.01,
      },
      loadImage: false,
      maxH: this.maxHeight ?? '100%',
      maxW: this.maxWidth ?? '100%',
      width: this.result?.width,
      height: this.result?.height,
    };
  },
  computed: {},
  watch: {
    maxWidth() {
      this.maxW = this.maxWidth;
    },
  },
  mounted() {
    try {
      if (this.priority) {
        this.loadImage = true;
      } else if (this.result && !this.intersectionObserver) {
        if ('IntersectionObserver' in window) {
          // LazyLoad images using IntersectionObserver
          this.intersectionObserver = new IntersectionObserver(this.observerCallBack, this.options);
          this.intersectionObserver.observe(this.$el);
        } else {
          // Load all images at once
          this.loadImage = true;
        }
      }
    } catch (err) {
      console.error(err);
    }
  },
  beforeUnmount() {
    try {
      if ('IntersectionObserver' in window && this.result && this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    } catch (err) {
      console.error(err);
    }
  },
  methods: {
    observerCallBack(entries) {
      try {
        // If intersectionRatio is 0, the target is out of view
        // and we do not need to do anything.
        // console.log(entries[0].intersectionRatio);
        if (entries[0].intersectionRatio <= 0) return;

        this.loadImage = true;
        this.intersectionObserver.unobserve(this.$el);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.def-img-wrapper {
  display: flex;
  width: 100%;
  aspect-ratio: v-bind(width) / v-bind(height);
  overflow: hidden;

  max-width: v-bind(maxW);
  max-height: v-bind(maxH);
}
.def-img {
  display: block;
  height: 100%;
  width: 100%;
  color: transparent;
  object-fit: contain;
}
</style>
